import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { QuestionGroupGuidelineCollapseExpand } from '@doltech/ui/lib/figma/QuestionGroupGuideline/QuestionGroupGuidelineCollapseExpand';
import renderNode, { Div } from '@doltech/ui/lib/figma/renderNode';
import * as mobx from 'mobx';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ExplanationWithSummaryDetail } from '../components/ExplanationWithSummaryDetail';
import { useTestResultStore } from '../model/test-result.hook';

export const Header = styled.h3`
  color: ${colorsV2.black100};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 0;
  flex: 1;

  display: grid;
  grid-auto-flow: column;
  grid-column: max-content;
  justify-content: space-between;
`;

const Main = styled.div`
  font-size: 14px;
  .hide {
    display: none;
  }

  .test-result-section {
    &:not(:last-child) {
      margin-bottom: 16px;
    }

    .section-test-header {
      margin-bottom: 8px;
    }

    .section-result-item {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }

    &.section-explanation {
      .section-test-header {
        display: flex;
        align-items: center;
      }
    }
  }
  .dol-question {
    position: relative;
  }
  .collapse-expand-toggle-wrapper {
    position: absolute;
    top: 4px;
    right: 4px;
    button:hover {
      background-color: unset !important;
    }
  }
  .question-content {
    position: relative;
  }

  .header-locate-passage {
    display: grid;
    grid-auto-flow: column;
    grid-column: max-content;
    align-items: center;
    gap: 12px;
  }
`;

export interface TestContentLayoutProps extends React.HTMLAttributes<HTMLDivElement> {
  explanationAction?: JSX.Element;
  renderExplanation?: JSX.Element;
}

export const TestContentLayout = observer((props: TestContentLayoutProps) => {
  const { children, explanationAction, renderExplanation, ...rest } = props;

  const store = useTestResultStore();
  const currentGroup = store.getCurrentGroup();
  const questionGroupHeader = currentGroup?.getQuestionGroupsFromNoToNo() || '...';
  const { content, enable } = currentGroup?.compactGuideline || { content: [] };

  return (
    <Main {...rest}>
      <div className="test-result-section section-result">
        <QuestionGroupGuidelineCollapseExpand
          className="section-result-item"
          key={currentGroup?.id}
          title={questionGroupHeader}
          content={mobx.toJS(currentGroup?.guideline?.content)}
          compactContent={mobx.toJS(content)}
          compactEnable={enable}
          initialExpandValue={false}
        />
        <div className="section-result-item question-content">{children}</div>
      </div>
      <div className="test-result-section section-explanation">
        {renderExplanation ? (
          renderNode(Div, renderExplanation, {})
        ) : (
          <>
            <div className="section-test-header">
              <Header>ĐÁP ÁN & GIẢI THÍCH CÂU {store.currentQuestionIndex + 1}</Header>
              {explanationAction}
            </div>
            <ExplanationWithSummaryDetail />
          </>
        )}
      </div>
    </Main>
  );
});
